// extracted by mini-css-extract-plugin
export default {"w2":"Profile_w2__5VV49","emailIcon":"Profile_emailIcon__w9mpM","nameIcon":"Profile_nameIcon__5hMHQ","fs18":"Profile_fs18__pQ0El","formBackground":"Profile_formBackground__+jjjp"};